import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import CreateEmailModal from "./create-email-modal";
import MarketingEmailsSelect from "./marketing-emails-select";
import { mapState } from "vuex";
import { showBModal } from "../../../../../../shared/components/bootstrap/BModal";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CampaignFromSection",
  components: {
    CreateEmailModal,
    MarketingEmailsSelect,
    MaterialInput
  },
  props: {
    save: {
      type: Boolean,
      default: true
    },
    noEdit: {
      type: Boolean,
      default: false
    },
    label: {
      type: Boolean,
      default: true
    },
    fromData: {
      type: Object,
      default: () => ({})
    },
    emails: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showVerifyEmail: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("MarketingStore", ["marketingEmails"])), {}, {
    emailNotVerified() {
      const currentSelectedEmail = this.marketingEmails.byId[this.fromData.email.emailId];
      return currentSelectedEmail && currentSelectedEmail.verified === false;
    },
    emailName: {
      get() {
        return this.fromData.emailName;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.fromData), {}, {
          emailName: value
        }));
      }
    }
  }),
  methods: {
    handleEmailNameChange(value) {
      this.emailName = value;
    },
    selectEmail({
      element
    }) {
      const emailId = element.value;
      const emailToAdd = this.marketingEmails.byId[emailId];
      this.$emit("change", _objectSpread(_objectSpread({}, this.fromData), {}, {
        email: emailToAdd
      }));
    },
    forceShowVerify() {
      this.showCreateEmailModal();
      this.showVerifyEmail = true;
    },
    resetForceShowVerify() {
      this.showVerifyEmail = false;
    },
    handleAutoSelectEmail(emailId) {
      const element = {
        value: emailId
      };
      this.selectEmail({
        element
      });
    },
    showCreateEmailModal() {
      showBModal("create-email-modal", {}, this);
    }
  }
});